<script lang="ts">
  import translationsStore from '../../../stores/translations.svelte'
  import videoStore from '../../../stores/video.svelte'
  import componentAttributesStore from '../../../stores/componentAttributes.svelte'
  import ChromecastEnabledIcon from '../icons/ChromecastEnabledIcon.svelte'
  import ChromecastIcon from '../icons/ChromecastIcon.svelte'
  import ControlBarButton from './ControlBarButton.svelte'
  import { CONTROL_BAR_BUTTON_TOOLTIP_POSITION } from './ControlBarButton.svelte'
  import { THEMES } from '../../../const/themes'
  import type { ControlBarButtonProps } from './ControlBarButton.svelte'

  let {
    tooltipPosition = CONTROL_BAR_BUTTON_TOOLTIP_POSITION.CENTER,
  }: Pick<ControlBarButtonProps, 'tooltipPosition'> = $props()
</script>

<ControlBarButton
  color={videoStore.state.isChromecasting
    ? componentAttributesStore.state.buttonsHoverColor ||
      THEMES.DEFAULT.BUTTONS_HOVER_COLOR
    : undefined}
  tooltip={videoStore.state.isChromecasting
    ? translationsStore.state.stop_chromecast
    : translationsStore.state.start_chromecast}
  {tooltipPosition}
  hidden={!videoStore.state.isChromecastSupported ||
    videoStore.state.isFullscreen ||
    videoStore.state.isWebkitFullscreen}
  onclick={() => videoStore.state.videoController?.toggleChromecast()}
>
  {#if videoStore.state.isChromecasting}
    <ChromecastEnabledIcon />
  {:else}
    <ChromecastIcon />
  {/if}
</ControlBarButton>
